//painel-admin/src/pages/SorteioLeadPublico.jsx

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "../axiosConfig";
import { CheckCircle2, Gift, Loader2, Send } from "lucide-react";
import "./SorteioLeadPublico.css";

function SorteioLeadPublico() {
  const { slug } = useParams();

  const [sorteio, setSorteio] = useState(null);
  const [loading, setLoading] = useState(true);
  const [enviando, setEnviando] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [mensagem, setMensagem] = useState("");

  const [form, setForm] = useState({
    nome: "",
    empresa: "",
    email: "",
    whatsapp: ""
  });

  useEffect(() => {
    axios
      .get(`/sorteios-leads/publico/${slug}`)
      .then((res) => {
        setSorteio(res.data.sorteio);
      })
      .catch((err) => {
        setMensagem(
          err.response?.data?.error ||
            "Este sorteio não está disponível no momento."
        );
      })
      .finally(() => setLoading(false));
  }, [slug]);

  const handleChange = (campo, valor) => {
    setForm((prev) => ({
      ...prev,
      [campo]: valor
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMensagem("");

    if (!form.nome.trim() || !form.email.trim() || !form.whatsapp.trim()) {
      setMensagem("Preencha nome, e-mail e WhatsApp para participar.");
      return;
    }

    setEnviando(true);

    try {
      const res = await axios.post(
        `/sorteios-leads/publico/${slug}/participar`,
        form
      );

      setSucesso(true);
      setMensagem(res.data?.message || "Cadastro confirmado!");
    } catch (err) {
      setMensagem(
        err.response?.data?.error ||
          "Não foi possível confirmar sua participação."
      );
    } finally {
      setEnviando(false);
    }
  };

  if (loading) {
    return (
      <div className="sorteioLeadPublico-page">
        <div className="sorteioLeadPublico-card compact">
          <Loader2 className="sorteioLeadPublico-spin" size={28} />
          <p>Carregando sorteio...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sorteioLeadPublico-page">
      <div className="sorteioLeadPublico-card">
        <div className="sorteioLeadPublico-logoBox">
          <img src="/logo2.png" alt="Tikpag" />
        </div>

        <div className="sorteioLeadPublico-icon">
          {sucesso ? <CheckCircle2 size={30} /> : <Gift size={30} />}
        </div>

        <span className="sorteioLeadPublico-kicker">Sorteio Especial</span>

        <h1>{sorteio?.titulo || "Sorteio Tikpag"}</h1>

        <p className="sorteioLeadPublico-desc">
          {sorteio?.descricao ||
            "Preencha seus dados para participar do sorteio de brindes da Tikpag."}
        </p>

        {sucesso ? (
          <div className="sorteioLeadPublico-success">
            <CheckCircle2 size={44} />
            <h2>Participação confirmada!</h2>
            <p>{mensagem}</p>
            <small>Boa sorte! O sorteio será realizado durante o evento.</small>
          </div>
        ) : (
          <form className="sorteioLeadPublico-form" onSubmit={handleSubmit}>
            <label>
              <span>Seu nome</span>
              <input
                type="text"
                value={form.nome}
                onChange={(e) => handleChange("nome", e.target.value)}
                placeholder="Digite seu nome"
                autoComplete="name"
              />
            </label>

            <label>
              <span>Empresa</span>
              <input
                type="text"
                value={form.empresa}
                onChange={(e) => handleChange("empresa", e.target.value)}
                placeholder="Nome da empresa"
                autoComplete="organization"
              />
            </label>

            <label>
              <span>E-mail</span>
              <input
                type="email"
                value={form.email}
                onChange={(e) => handleChange("email", e.target.value)}
                placeholder="seuemail@empresa.com.br"
                autoComplete="email"
              />
            </label>

            <label>
              <span>WhatsApp</span>
              <input
                type="tel"
                value={form.whatsapp}
                onChange={(e) => handleChange("whatsapp", e.target.value)}
                placeholder="(11) 99999-9999"
                autoComplete="tel"
                inputMode="tel"
              />
            </label>

            {mensagem && (
              <div className="sorteioLeadPublico-message">
                {mensagem}
              </div>
            )}

            <button type="submit" disabled={enviando}>
              {enviando ? (
                <>
                  <Loader2 className="sorteioLeadPublico-spin" size={18} />
                  Confirmando...
                </>
              ) : (
                <>
                  <Send size={18} />
                  Participar do sorteio
                </>
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default SorteioLeadPublico;
